import React, { useState, useEffect, memo } from 'react';
import { LoadingSpinner } from '../common/loadingSpinner';
import { useAppDispatch, useAppSelector } from '../redux/hooks'
import { apiSlice, useGetLimitedArticlesQuery } from '../redux/api-slice';
import Article from './Article';
import InfiniteScroll from 'react-infinite-scroll-component';
import { setSortType } from '../redux/settings/page-settings-slice';



export default function SubCategoryFilterContainer() {
    const dispatch = useAppDispatch();
    const reverseChronological = useAppSelector((state) => state.pageSettings.reverseChronologicalSortLabel);
    const chronological = useAppSelector((state) => state.pageSettings.chronologicalSortLabel);
    const reverseAlphabetical = useAppSelector((state) => state.pageSettings.reverseAlphabeticalSortLabel);
    const alphabetical = useAppSelector((state) => state.pageSettings.alphabeticalSortLabel);
    const sortByLabel = useAppSelector((state) => state.pageSettings.sortDropdownLabel);
    const initialFilterValue = useAppSelector((state) => state.pageSettings.sortType);
    const [selectedValue, setSelectedValue] = useState(initialFilterValue);
    const formatSortType = (value) => {
        dispatch(apiSlice.util.resetApiState());
        setSelectedValue(value);
        dispatch(setSortType(value));
    }

    useEffect(() => {
        setSelectedValue(selectedValue);
    }, [selectedValue]);
    
    return (
        <div className="otc-sort-container">
            <div className="select-container">
                <label htmlFor="sortByFilter" className="label">{sortByLabel}</label>
                <select id="sortByFilter" value={selectedValue} className="filter-select" onChange={(e) => formatSortType(e.target.value)}>
                    <option value="reverseChronological"> {reverseChronological} </option>
                    <option value="chronological"> {chronological} </option>
                    <option value="alphabetical"> {alphabetical} </option>
                    <option value="reverseAlphabetical"> {reverseAlphabetical} </option>
                </select>
            </div>
        </div>
    );
}
